<template>
  <div class="orgList-add app-container">
    <div class="global-header-wrap">
      <span>{{ $t("org.newOrg") }}</span>
      <button class="global-button-style" @click="$router.back()">
        {{ $t("commonMsg.back") }}
      </button>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="body-wrap">
        <el-form
          class="global-page-form"
          @submit.native.prevent
          :rules="rules"
          :model="params"
          ref="aa"
          label-width="80px"
        >
          <el-form-item
            :label="paramsProp[key]"
            v-for="(item, key) in params"
            :key="key"
            :prop="key"
          >
            <el-input v-model="params[key]"></el-input>
          </el-form-item>
          <el-form-item :label="$t('org.selectArea')" prop="area">
            <Area @areaHandle="areaHandle" />
          </el-form-item>
          <el-form-item>
            <button class="global-button-style" @click="onSubmit('aa')">
              {{ $t("commonMsg.create") }}
            </button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import Area from "@/components/area";

export default {
  components: {
    Area
  },
  computed: {
    rules() {
      let verifyFid = (rule, value, callback) => {
        if (!value) return callback(new Error(this.$t("verify.orgId")));
        else if (!/^[0-9]*$/.test(value))
          return callback(new Error(this.$t("verify.num")));

        this.$http
          .verifyFid({ fid: value })
          .then(res => {
            res.data
              ? callback(new Error(this.$t("verify.orgExist")))
              : callback();
          })
          .catch(() => {
            callback(new Error("请求失败"));
          });
      };
      let verifyArea = (rule, value, callback) => {
        if (!this.areaArr.length)
          return callback(new Error(this.$t("verify.orgId")));
        callback();
      };
      let rules = {
        name: [
          {
            required: true,
            message: this.$t("verify.orgName"),
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: this.$t("verify.orgAddress"),
            trigger: "blur"
          }
        ],
        fid: [{ required: true, validator: verifyFid, trigger: "blur" }],
        area: [{ required: true, validator: verifyArea, trigger: "blur" }]
      };
      return rules;
    },
    paramsProp() {
      let paramsProp = {
        fid: this.$t("org.orgId"),
        name: this.$t("org.orgName"),
        address: this.$t("org.orgAddress")
      };
      return paramsProp;
    }
  },
  data() {
    return {
      params: {
        fid: "",
        name: "",
        address: ""
      },

      areaArr: []
    };
  },

  methods: {
    areaHandle(value) {
      this.areaArr = value;
    },

    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.createOrg();
        } else {
          return false;
        }
      });
    },

    createOrg() {
      [this.params.province, this.params.city, this.params.area] = this.areaArr;
      this.$http.createOrg(this.params).then(res => {
        this.$router.back();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.body-wrap {
  height: 100%;
  .el-form {
    width: 50%;
    min-width: 300px;
    margin: 10px auto;
    .el-form-item {
      .el-select {
        width: 100%;
      }
      .el-textarea__inner {
        height: 150px;
      }
    }
    .global-button-style {
      width: 100%;
      margin: 0;
    }
  }
}
</style>
